import Cookie from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

import { DEVICE_ID } from 'shared/enums/SitePreferences';

/**
 * Returns the first-party device id, generating and persisting it on first call.
 * The browser is the only minter: the server never sets this cookie because
 * logged-out HTML is CDN-cached and a server Set-Cookie would either be dropped
 * or race the client. The id is stored in the `x-goat-device-id` cookie and
 * reused across visits (including ids minted by checkout-platform/goat-noir on
 * the same host); re-setting an existing value only extends the rolling expiry.
 */
export const identify = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const id = Cookie.get(DEVICE_ID.COOKIE) || uuidv4();

  Cookie.set(DEVICE_ID.COOKIE, id, {
    expires: 365,
    path: '/',
    sameSite: 'Lax',
    secure: window.location.protocol === 'https:',
  });

  return id;
};
